import React, { useState } from "react";
import { Link } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../hooks";
import { account } from "../actions/auth";
import { openMenu } from "../actions/menu";
import { Support } from "../../public/icons";
import Contacts from "./Contacts";
import Profile from "./account/Profile";
import styles from "../styles/Header.module.css";
import burger from "../../public/i/burger.svg";
import logo from "../../public/i/eDoc.svg";
import MediaQuery, { useMediaQuery } from "react-responsive";
import { IUser } from "../interfaces/user";
import { AccountSwitcher } from "./account/AccountSwitcher";

const hasSupportData = Boolean(
  process.env.SUPPORT_PHONE ||
  process.env.SUPPORT_MOBILE ||
  process.env.SUPPORT_EMAIL
);

interface NavbarProps {
  user: IUser;
  onSupportClick: () => void;
  onAccountClick: () => void;
  accountMenu: boolean;
}

function Navbar({
  user,
  onSupportClick,
  onAccountClick,
  accountMenu,
}: NavbarProps) {
  const isUserLoggedIn = !!user?.id;
  return (
    <nav>
      <ul className={styles.navlist}>
        {hasSupportData && (
          <li>
            <button
              type="button"
              className={styles.icon}
              onClick={onSupportClick}
            >
              <Support color="var(--blue)" height="27px" width="27px" />
            </button>
          </li>
        )}
        {isUserLoggedIn && (
          <li>
            <Profile user={user} />
            <button
              type="button"
              onClick={onAccountClick}
              className={accountMenu ? styles.etcActive : styles.etc}
            >
              <div></div>
              <div></div>
              <div></div>
            </button>
          </li>
        )}
      </ul>
    </nav>
  );
}

export default function Header() {
  const [supportMenu, setSupportMenu] = useState(false);
  const [accountMenu, setAccountMenu] = useState(false);
  const dispatch = useAppDispatch();
  // const location = useLocation();
  const menu = useAppSelector((state) => state.menu);
  const user = useAppSelector((state) => state.user);
  const isMobile = useMediaQuery({ maxWidth: 992 });
  const onSupportClick = () => {
    setAccountMenu(false);
    setSupportMenu(!supportMenu);
  };

  const onAccountClick = () => {
    setSupportMenu(false);
    setAccountMenu(!accountMenu);
  };

  const username = [user.lastname, user.firstname, user.middlename].filter(
    (el) => el?.length,
  );

  const switchAccount = (id) => {
    dispatch(account(id));
    setAccountMenu(!accountMenu);
  };


  const headerLogo = user.id ? (
    <Link to="/" className={styles.logo}>
      <img src={logo} alt="" />
    </Link>
  ) : (
    <img src={logo} alt="" />
  );

  document.addEventListener("click", function (event) {
    const headerPopup = document.getElementById("headerPopup");
    const modalWrapper = document.getElementById("modalWrapper");
    const isClickInsidePopup = headerPopup?.contains(event?.target);
    const isClickInsideModal = modalWrapper?.contains(event?.target);

    if (!isClickInsidePopup && isClickInsideModal) {
      setSupportMenu(false);
      setAccountMenu(false);
    }
  });

  const onBurgerClick = () => {
    dispatch(openMenu());
    setSupportMenu(false);
    setAccountMenu(false);
  };

  return (
    <header className={styles.header}>
      <div style={{ display: "flex", gap: "10px", alignItems: "center" }}>
        <MediaQuery maxWidth={1239}>
          {user.id && (
            <div className={styles.burger}>
              {menu.open ? null : (
                <button
                  className={styles.burger}
                  onClick={() => onBurgerClick()}
                >
                  <img src={burger} alt="" />
                </button>
              )}
            </div>
          )}
        </MediaQuery>
        {headerLogo}
      </div>
      <Navbar
        user={user}
        onSupportClick={onSupportClick}
        onAccountClick={onAccountClick}
        isMobile={isMobile}
        accountMenu={accountMenu}
      />
      {(supportMenu || accountMenu) && (
        <div className={styles.modalWrapper} id="modalWrapper">
          <div
            className={styles.headerPopup}
            id="headerPopup"
            style={{
              right:
                !isMobile && supportMenu
                  ? user?.id !== 0
                    ? "170px"
                    : undefined
                  : undefined,
            }}
          >
            {supportMenu && <Contacts />}
            {accountMenu && (
              <AccountSwitcher
              isMobile={isMobile}
              user={user} 
              username={username} 
              switchAccount={switchAccount} 
              setAccountMenu={setAccountMenu} 
            />
            )}
          </div>
        </div>
      )}
    </header>
  );
}


